/* eslint-disable no-undef */
const host = {
  local: 'http://jsonplaceholder.typicode.com/users',
  server: 'https://api.ashirobo.i3design.dev/',
  serverTest: process.env.REACT_APP_API_URL || 'https://api.ashirobo.i3design.dev/',
  recommend_server: process.env.REACT_APP_RECOMMEND_API_URL || 'http://localhost:5001/api/v2/',
  user_host: 'localhost:3000',
};

const env = {
  clientSecret: process.env.REACT_APP_CLIENT_SECRET,
};

export { host, env };